import api from './api';

const noteService = {
  // Get all notes
  getAllNotes: async (params = {}) => {
    const response = await api.get('/notes', { params });
    return response.data;
  },

  // Get single note
  getNote: async (id) => {
    const response = await api.get(`/notes/${id}`);
    return response.data;
  },

  // Create note
  createNote: async (noteData) => {
    const response = await api.post('/notes', noteData);
    return response.data;
  },

  // Update note
  updateNote: async (id, noteData) => {
    const response = await api.put(`/notes/${id}`, noteData);
    return response.data;
  },

  // Delete note
  deleteNote: async (id) => {
    const response = await api.delete(`/notes/${id}`);
    return response.data;
  },

  // Toggle pin
  togglePin: async (id) => {
    const response = await api.patch(`/notes/${id}/pin`);
    return response.data;
  },

  // Toggle archive
  toggleArchive: async (id) => {
    const response = await api.patch(`/notes/${id}/archive`);
    return response.data;
  },

  // Search notes
  searchNotes: async (query) => {
    const response = await api.get('/notes/search', { params: { q: query } });
    return response.data;
  },

  // Get categories
  getCategories: async () => {
    const response = await api.get('/notes/categories');
    return response.data;
  },
};

export default noteService;